const content: { [key: string]: any } = {
  userDelegationDetail: 'Assign User Delegation',
};

export default content;
